import React from 'react';
import styled from '@emotion/styled';
import { RawHtml } from '~/shared/components/RawHtml/RawHtml';
import { AccordionItem } from '~/shared/components/Accordion/components/AccordionItem/AccordionItem';
import { Accordion } from '~/shared/components/Accordion/Accordion';
import { FaqProps } from '../Summary.definitions';
import ChevronIcon from '~/icons/chevron-down.svg';
import { SectionTitle } from './SectionTitle/SectionTitle';
import { SectionText } from './SectionText';
import Typography from '../../Typography/Typography';

export const Chevron = styled.div<{ isOpen?: boolean }>(({ isOpen, theme }) => ({
    color: theme.colors.black,
    transform: `rotateX(${isOpen ? '180deg' : '0deg'})`,
    transition: 'transform 175ms ease-out',
}));

export const Faq = styled(({ title, faqs, className }: FaqProps) => {
    return (
        <div className={className}>
            {title && <SectionTitle>{title}</SectionTitle>}

            <Accordion>
                {faqs?.length
                    ? faqs.map((faq) => (
                          <AccordionItem
                              key={faq.headline}
                              initAsOpen
                              header={
                                  <Typography as="h2" variant="paragraph-S">
                                      {faq.headline}
                                  </Typography>
                              }
                              icon={({ isOpen }) => (
                                  <Chevron isOpen={isOpen}>
                                      <ChevronIcon />
                                  </Chevron>
                              )}
                          >
                              <SectionText>
                                  <RawHtml html={faq.description} />
                              </SectionText>
                          </AccordionItem>
                      ))
                    : []}
            </Accordion>
        </div>
    );
})({});
